"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTargets;
var _react = require("react");
var _contexts = require("../contexts");
var _domObserver = _interopRequireDefault(require("./dom-observer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function useTargets(currentContent) {
  const updateTrigger = (0, _domObserver.default)();
  const targetElements = useSelector(updateTrigger, currentContent);
  return targetElements;
}
function useSelector(updateTrigger, currentContent) {
  const {
    targetSelector
  } = (0, _react.useContext)(_contexts.Settings);
  return (0, _react.useMemo)(() => {
    if (typeof document === "undefined") return [];
    [].push(updateTrigger);
    [].push(currentContent);
    return Array.from(document.querySelectorAll(targetSelector));
  }, [targetSelector, updateTrigger, currentContent]);
}